import * as Scrivito from "scrivito";
import SectionWidget from "widgets/SectionWidget/SectionWidgetClass";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("CustomProductItem", {
  title: "Custom Product Item",
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
    isProdReady: {
      title: "Is Prod env ready?",
      description: "If yes,it will be show on production environment",
    },
  },

  properties: ["isProdReady", ...defaultPageProperties],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Custom Product Item",
    isProdReady: false,
    showConfiguratorNav: true,
    body: [new SectionWidget({})],
  },
  validations: [...defaultPageValidations, ...metadataValidations],
});
